module.exports = __webpack_public_path__ + "static/img/regulacni_ventil_2_zavitovy.3996168.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/regulacni_ventil_2_zavitovy.png
// module id = Jr0V
// module chunks = 1